import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { GlobalService } from 'src/app/global.service';
import { LoginService } from 'src/app/Common/Services/login.service';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator, MatTableDataSource } from '@angular/material';

export interface PeriodicElement {
  agentname: string;
  username: string;
  pin: string;
  usertype:string;
}

@Component({
  selector: 'app-pin-generaton',
  templateUrl: './pin-generaton.component.html',
  styleUrls: ['./pin-generaton.component.css']
})
export class PinGeneratonComponent implements OnInit {
  
  pingenForm:FormGroup;
  pinagentLists: any[] = [];
  usernames: any[] = [];
  userType:string;
  emailId:string;
  pin:any;
  editable: boolean = false;
  public UserType : boolean = false;
  public NewPin : boolean = false;
  public Submit : boolean = false;
  public GenPin : boolean = false;
  displayedColumns: string[] = ['agentname', 'username','usertype','pin'];
  dataSource ;

  pinGenerationList :PeriodicElement[] =[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  public agentCtrl: FormControl = new FormControl();

  constructor(public global: GlobalService,private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService) {

    this.pingenForm=this._formbuilder.group({
      pinagentList: ['',[Validators.required]],
      pin: ['',[Validators.required]],
      username:['',[Validators.required]],
      usertype:['',[Validators.required]]
    });
   }

  ngOnInit() {
    this.getAllLOvs("pin-generation");
    this.getpinGenerationList();
  }


  getAllLOvs(value:string){
    this.loginservice.getPageLOVs(value).subscribe((res:any)=>{
      if(res.responseBody != undefined){
        console.log("LOVs",res.responseBody);
        this.pinagentLists = res.responseBody.pinAgentList;
      }
    })
  }

  getpinGenerationList(){
    
    this.loginservice.getpinGenerationList().subscribe((res:any) => {
      if(res.responseBody != undefined){
        console.log("upload Listing :", res.responseBody);
        this.pinGenerationList = res.responseBody.list;
        console.log("Listing:", this.pinGenerationList)
        this.dataSource = new MatTableDataSource(this.pinGenerationList);
        this.dataSource.paginator = this.paginator;
      }
      
    })
  }

  userlist(val){
  
  console.log("List", val);
  this.loginservice.getloginuser(val).subscribe((res:any)=>{
    
    if(res.responseBody != undefined){
      console.log("List",res.responseBody);
      this.usernames = res.responseBody.list;
    }
  })
  }

  usertype(val){
    
    console.log("List", val);
    this.loginservice.getuserType(val).subscribe((res:any)=>{
      
      if(res.responseBody != undefined){
        console.log("List",res.responseBody.list);
        if(res.responseBody.list["0"].IBU_LOGIN_USR_USER_TYPE == "AGN"){
          this.userType = "AGENT"
        }else{
          this.userType = res.responseBody.list["0"].IBU_LOGIN_USR_USER_TYPE;
        }
        if(res.responseBody.list["0"].IBU_LOGIN_USR_EMAIL !=undefined){
          this.emailId = res.responseBody.list["0"].IBU_LOGIN_USR_EMAIL;
        }else{
          this.emailId = "";
        }
        this.pingenForm.patchValue({
          usertype: this.userType
        });
      }
      this.UserType = true;
      this.GenPin = true;
    })
  }

  generatePin(){
    
    var chars = "0123456789";   
    var string_length = 4; // This is the length of the Captcha    
    var ChangeCaptcha = '';
    for (var i=0; i<string_length; i++) {
     var rnum = Math.floor(Math.random() * chars.length);
      this.pin += chars.substring(rnum,rnum+1);
  }
  var lastFour = this.pin.substr(this.pin.length - 4);
  this.pin=lastFour;
  localStorage.setItem("pin",this.pin);
  console.log(this.pin);
  this.pingenForm.patchValue({
    pin:this.pin
  });
  this.NewPin = true;
  this.GenPin=false;
  this.Submit = true;
  this.toastr.success("PIN Generated Successfully", undefined, {
    positionClass: 'toast-bottom-right',
    timeOut: 6000
});

  }
  
  submit(pingenForm){
    
    if(this.pingenForm.valid){
      var userName = this.usernames["0"].value;
      if(this.emailId !=""){
       var email = this.emailId;
       var emailId = "durga.b@3i-infotech.com";
      }else{
        var emailId = "durga.b@3i-infotech.com";
      }
     this.pingenForm.value.name = userName;
     this.pingenForm.value.email = email;
     this.pingenForm.value.emailId = emailId;
    let Form = JSON.stringify(this.pingenForm.value);
    this.loginservice.savepingeneration(Form).subscribe((res: any)=>{
      console.log(res);
      
      if(res.responseBody.validationMsg){
        this.toastr.success(res.responseBody.validationMsg, undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
     });
     this.getpinGenerationList();
     this.getAllLOvs("pin-generation");
     this.pingenForm.reset();
     this.NewPin = false;
     this.UserType = false;
     this.Submit = false;
     this.GenPin = false;
      }
    })
  }
  }
}
